import { render } from "./plans.vue?vue&type=template&id=686273fd&scoped=true&lang=pug"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"

import "./plans.vue?vue&type=style&index=0&id=686273fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686273fd"]])

export default __exports__